import React, { useEffect, useLayoutEffect, useState } from "react"
import PropTypes from "prop-types"
import downArrow from "@/public/icons/down-arrow.svg"
import MissingImage from "@/public/images/image-missing.png"

import VideoWrapper from "@/components/VideoWrapper/VideoWrapper"
import useWindowResize from "@/hooks/useWindowResize"
import { debounce, getPDPPresetUrl, getAsPDPThumbnail } from "@/utils/helper"

const ProductGalleryViewer = props => {
  let imageListLength = props?.data?.length
  const viewMoreLink = imageListLength > 8 ? true : false
  const [selectedItem, setSelectedItem] = useState(0)
  const [width] = useWindowResize()
  const [presetConfig] = useState(props.presetConfigObject)
  const [imageData, setImageData] = useState(
    props.data && {
      ...props.data[selectedItem],
      url: getPDPPresetUrl(
        props.swatchUrl,
        presetConfig,
        props.data[selectedItem]?.url,
        width,
        props.data[selectedItem]?.template,
        props.accountName
      ),
    }
  )
  useLayoutEffect(
    debounce(() => {
      const tempImageData = props.data && {
        ...props.data[selectedItem],
        url: getPDPPresetUrl(
          props?.swatchUrl,
          presetConfig,
          props.data[selectedItem]?.url,
          width,
          props.data[selectedItem]?.template,
          props.accountName
        ),
      }
      setImageData(tempImageData)
    }),
    [width, props.data, selectedItem]
  )

  useEffect(() => {
    setSelectedItem(0)
  }, [props.data])
  let resourceTmpCredits =
    props &&
    props.productGalleryLabel &&
    props.productGalleryLabel.resourceCredit_s &&
    props.productGalleryLabel.resourceCredit_s.match("http") == null
      ? props.productGalleryLabel.resourceCredit_s
      : ""
  let showSku =
    props &&
    props.productData &&
    props.productData.category.match("Samples") !== null
      ? "SKU: " + props.productData.sku
      : ""
  let resourceCredits = showSku ? showSku : resourceTmpCredits
  let productDetailsForImage = props?.productDetailsForImage
  const handleChange = (index, resourceCredits = "") => {
    setSelectedItem(index)
    if (!showSku) {
      let resourceCreditsTxt =
        resourceCredits && resourceCredits.match("http") == null
          ? resourceCredits
          : ""
      document.querySelector(".image-reel__photo-credit").innerHTML =
        resourceCreditsTxt
    }
  }

  let badgeList = []
  if(props?.showSaleBadge) 
    badgeList.push(props?.staticTexts?.saleLabel)
  if(props?.productGalleryLabel?.newTag) 
    badgeList.push(props?.staticTexts?.newLabel)
  if(props?.productGalleryLabel?.productExclusive)
    badgeList.push(props?.staticTexts?.exclusiveLebel)

  let pdpBadgeName = badgeList.join(" & ")

  let imageList = props?.data
  let placeHolder = false
  if (props.data && props.data[0]) {
    if (!props.data[0].template) {
      if (props.placeholderImage) {
        imageList = props.placeholderImage
        placeHolder = true
      }
    }
  }

  let reelImageList = imageData
  if (imageData) {
    if (!imageData.template) {
      if (props.placeholderImage) {
        reelImageList.url = props.placeholderImage[0].url
        placeHolder = true
      }
    }
  }

  return (
    <React.Fragment>
      <div
        className={`${
          resourceCredits ? "image-reel row resourcecredits" : "image-reel row"
        }`}
      >
        <div className="image-reel__image-thumb-view no-print">
          <ul className="pl-0 ml-0 image-reel__image-thumb-view-ul">
            {imageList &&
              imageList.slice(0, 8).map((el, i) => {
                const urlParts = el.url.split("/")
                const id = urlParts[urlParts.length - 1]
                return (
                  <li key={i} className="image-reel__image-list">
                    <div
                      className={`image-reel_${
                        selectedItem === i ? "_thumbSelected" : "_image-thumb"
                      }`}
                      onClick={() => {
                        handleChange(i, el.resourceCredits)
                      }}
                    >
                      {el.type ? (
                        <VideoWrapper thumb videoId={el.url} />
                      ) : (
                        <img
                          onError={e => (e.target.src = MissingImage?.src)}
                          src={
                            placeHolder
                              ? el.url
                              : getAsPDPThumbnail(
                                  props.swatchUrl,
                                  props.presetConfig,
                                  id,
                                  props.accountName
                                )
                          }
                          alt="image"
                          className="img-fluid"
                          tabIndex="0"
                        />
                      )}
                    </div>
                  </li>
                )
              })}
            {viewMoreLink && (
              <div
                className="image-reel__image-view"
                onClick={() => props.handlePopup()}
              >
                <span
                  className="image-reel__link-more gbh-data-layer"
                  data-gbh-data-layer='{"eventAction":"pdp:product details:view gallery","eventName":"pdp:product details:view gallery","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"view gallery","internalLinkPosition":"pdp","internalLinkType":"pdp:navigation","internalLinkZoneName":"pdp:product details","internalLinkURL":"n/a","clickInternalLinks":"true"}'
                >
                  {props.staticTexts.viewLink}
                </span>
                <img src={downArrow?.src} alt="down-arrow" />
              </div>
            )}
          </ul>
        </div>

        <div className="image-reel__image-stack-view">
          <div className="image-reel__image-stack-view-block">
            {pdpBadgeName && (
              <div className="product-gallery__badge">
                <p className="product-gallery__new">{pdpBadgeName}</p>
              </div>
            )}
            <ul className="pl-0 list-inline image-reel__image-stack-list">
              {reelImageList && (
                <li>
                  {!reelImageList.type ? (
                    <img
                      onError={e => (e.target.src = MissingImage?.src)}
                      src={reelImageList.url}
                      alt="image"
                      className={`${
                        selectedItem === 0
                          ? "image-reel__stack-list-image print"
                          : "image-reel__stack-list-image no-print"
                      }`}
                    />
                  ) : (
                    <VideoWrapper videoId={reelImageList.url} height="350" />
                  )}
                </li>
              )}
            </ul>
          </div>
          {productDetailsForImage && (
            <p className="image-reel__product-details">
              {productDetailsForImage}{" "}
            </p>
          )}
          <p className="image-reel__photo-credit">{resourceCredits}</p>
        </div>
      </div>
    </React.Fragment>
  )
}

ProductGalleryViewer.defaultProps = {
  data: [],
  staticTexts: {},
}

ProductGalleryViewer.propTypes = {
  data: PropTypes.arrayOf(PropTypes.any).isRequired,
  staticTexts: PropTypes.object,
}

export default ProductGalleryViewer
